import * as React from 'react';
import { useEffect } from 'react';
import { useInstallApp } from '@wix/app-installer';
import { getPropsFromSearchParams } from '../../utils/getPropsFromSearchParams';
import { usePostInstallationUrl } from '../../utils/usePostInstallationUrl';

export const PageWithScriptInstaller = () => {
  const installApp = useInstallApp({
    platform: 'INSTALLER_STANDALONE',
  });
  const {
    appId,
    version,
    avoidPostInstallation,
    tenantType,
    tenantId,
    versionOverrideId,
    title,
    subtitle,
    ctaText,
    openInIframe,
    hideCloseButton,
    shareUrlId,
  } = getPropsFromSearchParams();

  const {
    redirectToPostInstallationUrlIfRequired,
    hasPostInstallationUrl,
    postInstallationUrl,
  } = usePostInstallationUrl();

  useEffect(() => {
    installApp({
      appId,
      shareUrlId,
      tenantType,
      tenantId,
      version,
      avoidPostInstallation: avoidPostInstallation || hasPostInstallationUrl,
      versionOverrideId,
      devModeSelectorTitle: title,
      devModeSelectorSubtitle: subtitle,
      devModeSelectorCtaText: ctaText,
      openInIframe,
      preventClosingDevSiteSelector: hideCloseButton,
      postInstallationUrl,
    })
      .then((response) => {
        redirectToPostInstallationUrlIfRequired(response);
      })
      .catch((e) => {
        console.error('installation failed', e);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};
